/* One card per reviewed model across the whole filtered collection, not per Shopify page. */
function createFirepitModels(root) {
  let initial = null, generation = 0;
  const pageSize = 24;
  function cancel() { generation++; initial?.abort(); initial = null; }
  function source(scope) {
    const el = scope.querySelector('[data-fp-collection-source]');
    if (!el) throw new Error('Missing model collection source');
    return JSON.parse(el.textContent);
  }
  async function prepare(scope, pretty, signal) {
    const first = source(scope), pages = new Map([[first.page, {scope, data:first}]]);
    // Two native pages for the current catalog; bounded sequential fetches share the abort signal.
    for (let page=1;page<=first.pages;page++) {
      if (pages.has(page)) continue;
      const url = new URL(pretty, location.origin);
      url.searchParams.set('section_id',root.dataset.sectionId);url.searchParams.set('page',String(page));
      for (const key of ['preview_theme_id','_ab','_fd','_sc']) {
        const value = new URL(location.href).searchParams.get(key);if(value)url.searchParams.set(key,value);
      }
      const response = await fetch(url,{signal,headers:{'X-Requested-With':'XMLHttpRequest'}});
      if(!response.ok)throw new Error('Unable to load model choices');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html'), next=doc.querySelector('[data-efxc]');
      const data=source(next);if(data.page!==page||data.total!==first.total)throw new Error('Collection changed while loading');
      pages.set(page,{scope:next,data});
    }
    if(signal?.aborted)throw new DOMException('Aborted','AbortError');
    const models=new Map(), cards=new Map();
    [...pages].sort((a,b)=>a[0]-b[0]).forEach(([,entry])=>{
      entry.scope.querySelectorAll('[data-fp-card]').forEach(card=>{if(!cards.has(card.dataset.fpCard))cards.set(card.dataset.fpCard,card);});
      entry.data.rows.forEach(row=>{
        const current=models.get(row.key);
        if(!current)models.set(row.key,{...row,count:1});
        else{current.count++;if(row.price<current.price){current.price=row.price;current.money=row.money;}}
      });
    });
    const grid=scope.querySelector('[data-efxc-grid]');
    if(!grid && models.size)throw new Error('Missing model grid');
    const ordered=[...models.values()],sort=new URL(pretty,location.origin).searchParams.get('sort_by')||scope.dataset.sort;
    if(sort==='price-ascending')ordered.sort((a,b)=>a.price-b.price);
    if(sort==='price-descending')ordered.sort((a,b)=>b.price-a.price);
    if(sort==='title-ascending'||sort==='title-descending')ordered.sort((a,b)=>(sort==='title-descending'?-1:1)*cards.get(a.key).querySelector('.efx-card__title').textContent.localeCompare(cards.get(b.key).querySelector('.efx-card__title').textContent));
    const fragment=document.createDocumentFragment(),rail=pages.get(1).scope.querySelector('.efxc-rail');
    ordered.forEach((model,index)=>{
      const card=cards.get(model.key);if(!card)throw new Error('Missing model card '+model.key);
      const clone=card.cloneNode(true),price=clone.querySelector('.efx-price');
      if(price)price.textContent=(clone.dataset.fpFrom==='true'?'From ':'')+model.money;
      clone.hidden=index>=pageSize;fragment.appendChild(clone);
      if(index===3&&rail)fragment.appendChild(rail.cloneNode(true));
    });
    if(grid){grid.replaceChildren(fragment);grid.dataset.fpComplete='true';}
    const countLabel=ordered.length+' '+(ordered.length===1?'model':'models');
    const count=scope.querySelector('[data-efxc-swap="count"]');if(count)count.textContent=countLabel;
    const applyCount=scope.querySelector('[data-efxc-swap="applycount"]');if(applyCount)applyCount.textContent=countLabel;
    const more=scope.querySelector('.efxc-more');
    if(more){more.replaceChildren();const note=document.createElement('p');note.className='efxc-more__note';note.dataset.fpCount='';more.append(note);
      if(ordered.length>pageSize){const button=document.createElement('button');button.type='button';button.className='efx-btn efx-btn--ghost';button.dataset.fpMore='';button.textContent='Load more models';more.append(button);}updateCount(scope);
    }
    scope.dataset.fpModelCount=String(ordered.length);
    return ordered.length;
  }
  function updateCount(scope) {
    const all=[...scope.querySelectorAll('[data-fp-card]')],shown=all.filter(el=>!el.hidden).length;
    const note=scope.querySelector('[data-fp-count]');if(note)note.textContent='Showing '+shown+' of '+all.length+' models';
  }
  root.addEventListener('click',event=>{
    const button=event.target.closest('[data-fp-more]');if(!button)return;
    event.preventDefault();const hidden=[...root.querySelectorAll('[data-fp-card][hidden]')],added=hidden.slice(0,pageSize);
    added.forEach(el=>el.hidden=false);if(hidden.length<=pageSize)button.remove();updateCount(root);added[0]?.focus({preventScroll:true});
  });
  async function start() {
    cancel();const token=generation,ac=new AbortController();initial=ac;
    try{await prepare(root,location.href,ac.signal);if(token!==generation)return;root.dataset.fpReady='true';}
    catch(error){if(error.name==='AbortError')return;
      // Keep server-rendered, grouped cards and real pagination usable on network failure.
      const more=root.querySelector('.efxc-more');if(more){const note=document.createElement('p');note.textContent='More models are available on the next catalog page.';more.prepend(note);}
    }
  }
  return {prepare,start,cancel};
}

/* EFX collection — filter / sort / paginate without a full page load.
 *
 * Contract: every state is a real URL.
 *   tags  → /collections/<handle>/<tag>+<tag>        (Shopify-native tag path)
 *   price → ?filter.v.price.gte / .lte               (Shopify-native price filter)
 *   sort  → ?sort_by
 * The same URL rendered by the server produces the same page, so the back button,
 * a shared link and a crawler all behave. The AJAX path only asks Shopify to render
 * this one section (`?section_id=`) and swaps the marked regions.
 */

const root = document.querySelector('[data-efxc]');
if (root && !root.hasAttribute('data-bbq-collection')) init(root);

/* Filter bar: pinned state (T-COL2). A 1px sentinel above the bar, observed with a top
 * root-margin equal to the header height — the bar is pinned exactly when the sentinel has
 * been pushed up under the header. No scroll listener, no per-frame layout read.
 * The bar is opaque either way; .is-stuck only adds the depth shadow. */
const efxcBar = document.querySelector('.efxc-bar');
if (efxcBar) {
  const hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--efx-header-h'), 10) || 64;
  const sentinel = document.createElement('div');
  sentinel.setAttribute('aria-hidden', 'true');
  sentinel.style.cssText = 'height:1px;margin-bottom:-1px;pointer-events:none;';
  efxcBar.parentNode.insertBefore(sentinel, efxcBar);
  new IntersectionObserver(
    ([e]) => efxcBar.classList.toggle('is-stuck', !e.isIntersecting && e.boundingClientRect.top < hh),
    { rootMargin: `-${hh}px 0px 0px 0px`, threshold: 0 }
  ).observe(sentinel);
}

/* Buying-guide expander (efx-collection-content). Independent of the grid. */
document.querySelectorAll('[data-efxc-prose-toggle]').forEach(btn => {
  const prose = btn.closest('.efxc-guide__main')?.querySelector('[data-efxc-prose]');
  if (!prose) { btn.hidden = true; return; }
  /* Nothing to expand → no control. */
  if (prose.scrollHeight <= prose.clientHeight + 8) { btn.hidden = true; prose.classList.remove('is-clamped'); return; }
  btn.addEventListener('click', () => {
    const open = prose.classList.toggle('is-clamped') === false;
    btn.setAttribute('aria-expanded', String(open));
    btn.querySelector('span').textContent = open ? 'Show less' : 'Read the full guide';
    btn.querySelector('svg').style.transform = open ? 'rotate(180deg)' : '';
    if (!open) btn.scrollIntoView({ block: 'center', behavior: 'smooth' });
  });
});

function init(root) {
  const fpModels = root.hasAttribute("data-fp-model-collection") ? createFirepitModels(root) : null;
  const sectionId = root.dataset.sectionId;
  const baseUrl = root.dataset.collectionUrl;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Params that must survive every navigation (theme preview, tracking suppressors). */
  const CARRY = ['preview_theme_id', '_ab', '_fd', '_sc'];

  const state = readState(location.href);
  // Retired filter: old shared links keep their other filters and sorting.
  if (state.tags.some(tag => tag.toLowerCase() === 'vendor:leet')) {
    state.tags = state.tags.filter(tag => tag.toLowerCase() !== 'vendor:leet');
    location.replace(buildUrl());
    return;
  }
  const arrangeFilms = mantelFilmPairing(root);
  arrangeFilms();

  /* ---------- URL ⇄ state ---------- */
  function readState(href) {
    const u = new URL(href, location.origin);
    const base = new URL(baseUrl, location.origin).pathname.replace(/\/$/, '');
    let tags = [];
    if (u.pathname.startsWith(base + '/')) {
      const rest = u.pathname.slice(base.length + 1).replace(/\/$/, '');
      if (rest) tags = rest.split('+').map(decodeURIComponent).filter(Boolean);
    }
    return {
      tags,
      sort: u.searchParams.get('sort_by') || root.dataset.sort || '',
      priceMin: u.searchParams.get('filter.v.price.gte'),
      priceMax: u.searchParams.get('filter.v.price.lte'),
    };
  }

  function buildUrl(st = state) {
    const u = new URL(baseUrl, location.origin);
    u.pathname = u.pathname.replace(/\/$/, '');
    if (st.tags.length) u.pathname += '/' + st.tags.map(encodeURIComponent).join('+');
    if (st.sort) u.searchParams.set('sort_by', st.sort);
    if (st.priceMin) u.searchParams.set('filter.v.price.gte', st.priceMin);
    if (st.priceMax) u.searchParams.set('filter.v.price.lte', st.priceMax);
    const here = new URL(location.href);
    for (const k of CARRY) if (here.searchParams.has(k)) u.searchParams.set(k, here.searchParams.get(k));
    return u.pathname + (u.search ? u.search : '');
  }

  /* ---------- Render ---------- */
  const results = () => root.querySelector('[data-efxc-swap="results"]');
  let inflight = null;
  let moreRequest = null;

  function cancelLoadMore() {
    const job = moreRequest;
    if (!job) return;
    moreRequest = null;
    job.controller.abort();
    if (job.button.isConnected) {
      job.button.disabled = false;
      job.button.textContent = job.label;
    }
  }

  async function load(pretty, { push = true, scroll = false } = {}) {
    // This model view is route-scoped; a fresh document resets its family engine safely.
    const gasBase = '/collections/gas-logs';
    if (new URL(baseUrl, location.origin).pathname.replace(/\/$/, '') === gasBase) {
      const target = new URL(pretty, location.origin);
      const targetTags = target.pathname.startsWith(gasBase + '/')
        ? target.pathname.slice(gasBase.length + 1).replace(/\/$/, '').split('+').map(decodeURIComponent)
        : [];
      const wasGrouped = root.hasAttribute('data-efgst-collection');
      const nextGrouped = targetTags.includes('type:see-through');
      const wasOutdoor = root.dataset.efGasBaseTag === 'type:outdoor';
      const nextOutdoor = targetTags.includes('type:outdoor');
      if (wasGrouped !== nextGrouped || wasOutdoor !== nextOutdoor) {
        location.href = pretty;
        return;
      }
    }
    cancelLoadMore();
    fpModels?.cancel();
    const res = results();
    const fetchUrl = new URL(pretty, location.origin);
    fetchUrl.searchParams.set('section_id', sectionId);

    if (inflight) inflight.abort();
    const ac = new AbortController();
    inflight = ac;

    res.setAttribute('aria-busy', 'true');
    res.classList.add('is-loading');

    let html;
    try {
      const r = await fetch(fetchUrl.toString(), { signal: ac.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!r.ok) throw new Error(r.status);
      html = await r.text();
    } catch (e) {
      if (e.name === 'AbortError') return;
      location.href = pretty;           // never leave the customer on a stale grid
      return;
    }
    if (ac !== inflight) return;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector('[data-efxc]');
    if (!next) { location.href = pretty; return; }
    if(fpModels){try{await fpModels.prepare(next,pretty,ac.signal);}catch(error){if(error.name!=='AbortError')location.href=pretty;return;}}
    if(ac!==inflight)return;

    // Preserve keyboard position if a selected drawer control is re-rendered.
    const activeFilter = document.activeElement;
    const filterKey = activeFilter?.closest('[data-efxc-swap="drawer"]')
      ? ['data-efxc-tag', 'data-efxc-price-max', 'data-efxc-price-min', 'href'].map(name => [name, activeFilter.getAttribute(name)]).find(([, value]) => value !== null)
      : null;
    const activeBrowse = activeFilter?.closest('[data-efxc-browse-tag], [data-efxc-browse-all]');
    const browseFocus = activeBrowse ? {
      group: activeBrowse.closest('[data-efxc-browse-group]')?.getAttribute('data-efxc-browse-group'),
      tag: activeBrowse.getAttribute('data-efxc-browse-tag'),
      all: activeBrowse.hasAttribute('data-efxc-browse-all')
    } : null;
    /* Swap every marked region by name — one rule, no per-widget wiring. */
    root.querySelectorAll('[data-efxc-swap]').forEach(oldEl => {
      const name = oldEl.dataset.efxcSwap;
      const newEl = next.querySelector(`[data-efxc-swap="${name}"]`);
      if (newEl) oldEl.replaceWith(newEl);
    });

    if (filterKey && !activeFilter.isConnected && drawer?.classList.contains('is-open')) {
      const [name, value] = filterKey;
      const replacement = [...drawer.querySelectorAll('[' + name + ']')].find(el => el.getAttribute(name) === value);
      (replacement || drawer.querySelector('button[data-efxc-close-drawer]'))?.focus({ preventScroll: true });
    }
    if (browseFocus && !activeBrowse.isConnected) {
      const row = [...root.querySelectorAll('[data-efxc-browse-group]')]
        .find(el => el.getAttribute('data-efxc-browse-group') === browseFocus.group);
      const replacement = [...(row?.querySelectorAll('[data-efxc-browse-tag], [data-efxc-browse-all]') || [])]
        .find(el => browseFocus.all ? el.hasAttribute('data-efxc-browse-all') : el.getAttribute('data-efxc-browse-tag') === browseFocus.tag);
      replacement?.focus({ preventScroll: true });
    }
    arrangeFilms();
    root.dataset.tags = next.dataset.tags || '';
    root.dataset.sort = next.dataset.sort || '';
    const sel = root.querySelector('[data-efxc-sort]');
    if (sel) sel.value = state.sort || 'manual';
    paintPriceOptions();
    paintBrowseTabs();
    setupBrowseScroll();

    if (push && pretty !== location.pathname + location.search) history.pushState({ efxc: 1 }, '', pretty);
    if (scroll) {
      // The filter bar is sticky at pagination; use the section's stable document position.
      const header = document.getElementById('efx-header');
      const overlay = header && header.getClientRects().length && /^(fixed|sticky)$/.test(getComputedStyle(header).position);
      const headerRect = overlay ? header.getBoundingClientRect() : null;
      // A hidden shopping header returns while scrolling upward: reserve its full height.
      const clearance = headerRect ? Math.max(0, headerRect.bottom, headerRect.height) : 0;
      const top = window.scrollY + root.getBoundingClientRect().top - clearance - 12;
      window.scrollTo({ top: Math.max(0, top), behavior: reduced ? 'instant' : 'smooth' });
    }
    const r2 = results();
    r2.setAttribute('aria-busy', 'false');
    r2.classList.remove('is-loading');
  }

  function apply(opts) { scheduleBrowseAvailability(); load(buildUrl(), opts); }

  /* Reflect price selection on the drawer buttons (they are not tag-driven). */
  function paintPriceOptions() {
    root.querySelectorAll('[data-efxc-price-max]').forEach(b =>
      b.setAttribute('aria-pressed', String(state.priceMax === b.dataset.efxcPriceMax && !state.priceMin)));
    root.querySelectorAll('[data-efxc-price-min]').forEach(b =>
      b.setAttribute('aria-pressed', String(state.priceMin === b.dataset.efxcPriceMin && !state.priceMax)));
  }
  paintPriceOptions();

  let browseResizeObserver;
  function setupBrowseScroll() {
    browseResizeObserver?.disconnect();
    const update = box => {
      const rail = box.querySelector('[data-efxc-browse-group]');
      const prev = box.querySelector('[data-efxc-browse-prev]');
      const next = box.querySelector('[data-efxc-browse-next]');
      if (!rail || !prev || !next) return;
      // Use full box width, so revealing arrows cannot create an overflow loop.
      const overflow = rail.scrollWidth > box.clientWidth + 2;
      prev.hidden = next.hidden = !overflow;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    };
    const boxes = [...root.querySelectorAll('[data-efxc-browse-scroll]')];
    if (!boxes.length) return;
    browseResizeObserver = new ResizeObserver(() => boxes.forEach(update));
    boxes.forEach(box => {
      const rail = box.querySelector('[data-efxc-browse-group]');
      if (!rail) return;
      update(box);
      browseResizeObserver.observe(box);
      if (box.dataset.scrollReady) return;
      box.dataset.scrollReady = 'true';
      rail.addEventListener('scroll', () => update(box), {passive:true});
      box.addEventListener('click', e => {
        const button = e.target.closest('[data-efxc-browse-prev], [data-efxc-browse-next]');
        if (!button) return;
        e.preventDefault();
        const direction = button.hasAttribute('data-efxc-browse-prev') ? -1 : 1;
        rail.scrollBy({left:direction * Math.max(120,rail.clientWidth * .75),behavior:reduced ? 'instant' : 'smooth'});
      });
      rail.addEventListener('focusin', e => {
        const link = e.target.closest('a');
        if (!link) return;
        const item = link.getBoundingClientRect(), frame = rail.getBoundingClientRect();
        if (item.left < frame.left) rail.scrollLeft += item.left - frame.left;
        else if (item.right > frame.right) rail.scrollLeft += item.right - frame.right;
      });
      const selected = rail.querySelector('a[aria-current="true"]');
      if (selected) {
        const item = selected.getBoundingClientRect(), frame = rail.getBoundingClientRect();
        if (item.right > frame.right) rail.scrollLeft += item.right - frame.right;
      }
      update(box);
    });
  }

  // Browse shortcuts replace their namespace; different dimensions can combine.
  function browseGroupTags(row) {
    return (row.getAttribute('data-efxc-browse-group') || '').split(',').map(tag => tag.trim()).filter(Boolean);
  }
  function browseExactTags(row) {
    return (row.getAttribute('data-efxc-browse-exact-tags') || '').split(',').map(tag => tag.trim()).filter(Boolean);
  }
  function nextBrowseTags(row, tag, all) {
    const group = browseGroupTags(row);
    const exact = browseExactTags(row);
    const namespace = tag?.split(':')[0];
    const namespaces = group.filter(value => !exact.includes(value)).map(value => value.split(':')[0]);
    const toggleOff = !all && state.tags.includes(tag);
    const tags = state.tags.filter(value => all
      ? !exact.includes(value) && !namespaces.includes(value.split(':')[0])
      : exact.includes(tag) ? value !== tag : value.split(':')[0] !== namespace);
    if (!all && !toggleOff) tags.push(tag);
    return tags;
  }

  // Availability is native filtered membership, not a guessed compatibility matrix.
  // Shared quick filters; unknown/failed checks leave native links available.
  const browseAvailabilityCache = new Map();
  let browseAvailabilityTimer = null, browseAvailabilityAbort = null;
  function nextSimpleTags(tag) {
    const singleChoiceGroups = ['style', 'material', 'vendor', 'size', 'widthband', 'btuband',
      'vent', 'fuel', 'view', 'shape', 'install', 'location', 'tech', 'type', 'glass', 'finish'];
    const active = state.tags.includes(tag), ns = tag.split(':')[0];
    let tags = state.tags.filter(value => value !== tag);
    if (!active) {
      if (singleChoiceGroups.includes(ns)) tags = tags.filter(value => value.split(':')[0] !== ns);
      tags.push(tag);
    }
    return tags;
  }
  function setBrowseAvailability(link, count) {
    const tag = link.dataset.efxcBrowseTag || link.dataset.efxcTag;
    const disabled = count === 0 && !state.tags.includes(tag);
    if (disabled) {
      link.setAttribute('aria-disabled', 'true');
      link.setAttribute('title', 'No matching products with the current options');
    } else {
      link.removeAttribute('aria-disabled');
      link.removeAttribute('title');
    }
    if (Number.isInteger(count)) link.dataset.efxcBrowseCount = String(count);
    else delete link.dataset.efxcBrowseCount;
  }
  function scheduleBrowseAvailability() {
    clearTimeout(browseAvailabilityTimer);
    browseAvailabilityAbort?.abort();
    const panels = [...root.querySelectorAll('[data-efxc-swap="chips"], .effcn__secondary')];
    const allLinks = panels.flatMap(panel => [...panel.querySelectorAll('[data-efxc-browse-tag],[data-efxc-tag]')]);
    allLinks.forEach(link => setBrowseAvailability(link, null));
    // Closed mobile disclosures do not trigger speculative requests.
    const links = [...new Set(panels.filter(panel => panel.getClientRects().length)
      .flatMap(panel => [...panel.querySelectorAll('[data-efxc-browse-tag],[data-efxc-tag]')]))];
    if (!links.length) return;
    const snapshot = buildUrl();
    browseAvailabilityTimer = setTimeout(async () => {
      const controller = new AbortController();
      browseAvailabilityAbort = controller;
      const current = () => !controller.signal.aborted && root.isConnected && buildUrl() === snapshot;
      const jobs = [];
      links.forEach(link => {
        const tag = link.dataset.efxcBrowseTag || link.dataset.efxcTag;
        // A selected choice is always removable, even when the current result is empty.
        if (state.tags.includes(tag)) return;
        const row = link.closest('[data-efxc-browse-group]');
        const tags = link.hasAttribute('data-efxc-browse-tag') && row
          ? nextBrowseTags(row, tag, false) : nextSimpleTags(tag);
        const url = new URL(buildUrl({...state, tags}), location.origin);
        url.searchParams.set('section_id', 'ef-collection-summary-data');
        url.searchParams.delete('page');
        jobs.push({link, url: url.href});
      });
      async function worker() {
        while (jobs.length && current()) {
          const {link, url} = jobs.shift();
          try {
            let cached = browseAvailabilityCache.get(url);
            if (!cached || Date.now() - cached.at > 60000) {
              const response = await fetch(url, {signal:controller.signal, headers:{'X-Requested-With':'XMLHttpRequest'}});
              if (!response.ok) throw new Error('Availability request failed');
              const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
              const source = doc.querySelector('[data-ef-summary-source]');
              const data = source && JSON.parse(source.textContent);
              if (!data || !Number.isInteger(data.total) || data.total < 0) throw new Error('Missing native availability count');
              cached = {at:Date.now(), count:data.total};
              if (!current()) return;
              browseAvailabilityCache.set(url, cached);
            }
            if (current() && link.isConnected) setBrowseAvailability(link, cached.count);
          } catch (error) {
            if (error.name === 'AbortError' || !current()) return;
            if (link.isConnected) setBrowseAvailability(link, null);
          }
        }
      }
      await Promise.all([worker(), worker()]);
    }, 120);
  }
  new MutationObserver(scheduleBrowseAvailability).observe(root, {attributes:true, attributeFilter:['data-ef-quick-open']});
  matchMedia('(min-width:768px)').addEventListener('change', scheduleBrowseAvailability);
  function paintBrowseTabs() {
    // Legacy secondary rails can mix local facets and real category destinations.
    // Promote only a single native tag in this exact collection to shared AJAX behavior.
    const collectionPath = new URL(root.dataset.collectionUrl || buildUrl().split('?')[0].split('/').slice(0,3).join('/'), location.origin).pathname.replace(/\/$/, '');
    root.querySelectorAll('.effcn__secondary').forEach(row => {
      row.querySelectorAll('a[href]').forEach(link => {
        if (link.hasAttribute('data-efxc-browse-tag')) return;
        try {
          const url = new URL(link.href, location.origin);
          if (url.origin !== location.origin || !url.pathname.startsWith(collectionPath + '/')) return;
          const tail = url.pathname.slice(collectionPath.length + 1);
          if (!tail || tail.includes('/') || tail.includes('+')) return;
          const tag = decodeURIComponent(tail);
          if (!/^[a-z][a-z0-9_-]*:[^+/,]+$/.test(tag)) return;
          link.dataset.efxcBrowseTag = tag;
        } catch (_) { /* Native navigation remains the safe fallback. */ }
      });
      const tags = [...row.querySelectorAll('[data-efxc-browse-tag]')].map(link => link.dataset.efxcBrowseTag);
      if (tags.length) row.dataset.efxcBrowseGroup = tags.join(',');
    });
    root.querySelectorAll('[data-efxc-browse-group]').forEach(row => {
      const group = browseGroupTags(row);
      const exact = browseExactTags(row);
      const namespaces = group.filter(tag => !exact.includes(tag)).map(tag => tag.split(':')[0]);
      const any = state.tags.some(tag => exact.includes(tag) || namespaces.includes(tag.split(':')[0]));
      row.querySelectorAll('[data-efxc-browse-tag], [data-efxc-browse-all]').forEach(link => {
        const on = link.hasAttribute('data-efxc-browse-all') ? !any : state.tags.includes(link.dataset.efxcBrowseTag);
        link.classList.toggle('is-active', on);
        if (row.matches('.effcn__secondary') && link.dataset.efxcBrowseTag) link.href = buildUrl({...state, tags:nextBrowseTags(row, link.dataset.efxcBrowseTag, false)});
        if (on) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
      });
    });
    scheduleBrowseAvailability();
  }
  paintBrowseTabs();
  setupBrowseScroll();

  /* ---------- Interactions (delegated: survives every swap) ---------- */
  root.addEventListener('click', e => {
    const browseLink = e.target.closest('[data-efxc-browse-tag], [data-efxc-browse-all]');
    if (browseLink) {
      if (browseLink.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
      if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button > 0) return;
      const row = browseLink.closest('[data-efxc-browse-group]');
      if (!row) return;
      const group = browseGroupTags(row);
      const all = browseLink.hasAttribute('data-efxc-browse-all');
      const tag = browseLink.dataset.efxcBrowseTag;
      if (!all && !group.includes(tag)) return;
      e.preventDefault();
      const tags = nextBrowseTags(row, tag, all);
      const unchanged = tags.length === state.tags.length && tags.every(value => state.tags.includes(value));
      state.tags = tags;
      paintBrowseTabs();
      browseLink.focus({ preventScroll: true });
      if (!unchanged) apply({ scroll: false });
      return;
    }
    const clearNamespace = e.target.closest('[data-efxc-clear-namespace]');
    if (clearNamespace && root.hasAttribute('data-efmc-collection')) {
      e.preventDefault();
      const namespace = clearNamespace.dataset.efxcClearNamespace;
      if (namespace === 'material' || namespace === 'vendor') {
        state.tags = state.tags.filter(tag => tag.split(':')[0] !== namespace);
        apply();
      }
      return;
    }
    const tagBtn = e.target.closest('[data-efxc-tag]');
    if (tagBtn) {
      if (tagBtn.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
      const tag = tagBtn.dataset.efxcTag;
      const i = state.tags.indexOf(tag);
      /* Shopify tag paths combine with AND. Replace a previous categorical choice;
         different groups, additive features and compatible fit requirements still combine. */
      const ns = tag.split(':')[0];
      const singleChoiceGroups = ['style', 'material', 'vendor', 'size', 'widthband', 'btuband',
        'vent', 'fuel', 'view', 'shape', 'install', 'location', 'tech', 'type', 'glass', 'finish'];
      if (i < 0 && singleChoiceGroups.includes(ns)) {
        state.tags = state.tags.filter(x => x.split(':')[0] !== ns);
        root.querySelectorAll('[data-efxc-tag]').forEach(b => {
          if (b.dataset.efxcTag.split(':')[0] === ns) b.setAttribute('aria-pressed', 'false');
        });
      }
      if (i >= 0) state.tags.splice(i, 1); else state.tags.push(tag);
      tagBtn.setAttribute('aria-pressed', String(i < 0));
      apply();
      return;
    }

    const clear = e.target.closest('[data-efxc-clear]');
    if (clear) {
      e.preventDefault();
      state.tags = root.dataset.efGasBaseTag ? [root.dataset.efGasBaseTag] : []; state.priceMin = null; state.priceMax = null;
      apply();
      return;
    }

    const priceBtn = e.target.closest('[data-efxc-price-max], [data-efxc-price-min]');
    if (priceBtn) {
      const max = priceBtn.dataset.efxcPriceMax || null;
      const min = priceBtn.dataset.efxcPriceMin || null;
      const already = priceBtn.getAttribute('aria-pressed') === 'true';
      state.priceMax = already ? null : max;
      state.priceMin = already ? null : min;
      paintPriceOptions();
      apply();
      return;
    }

    const page = e.target.closest('[data-efxc-page]');
    if (page) { e.preventDefault(); load(withCarry(page.getAttribute('href')), { scroll: true }); return; }

    const more = e.target.closest('[data-efxc-loadmore]');
    if (more) { e.preventDefault(); loadMore(more); return; }

    if (e.target.closest('[data-efxc-open-drawer]')) { openDrawer(); return; }
    if (e.target.closest('[data-efxc-close-drawer]')) { closeDrawer(); return; }
  });

  root.addEventListener('change', e => {
    const sel = e.target.closest('[data-efxc-sort]');
    if (!sel) return;
    state.sort = sel.value;
    apply();
  });

  function withCarry(href) {
    const u = new URL(href, location.origin);
    const here = new URL(location.href);
    for (const k of CARRY) if (here.searchParams.has(k)) u.searchParams.set(k, here.searchParams.get(k));
    return u.pathname + u.search;
  }

  /* ---------- Load more (append, do not replace) ---------- */
  async function loadMore(btn) {
    if (moreRequest || results()?.getAttribute('aria-busy') === 'true') return;
    const grid = root.querySelector('[data-efxc-grid]');
    if (!grid || !grid.isConnected || !btn.isConnected) return;
    const pretty = withCarry(btn.dataset.url);
    const u = new URL(pretty, location.origin);
    u.searchParams.set('section_id', sectionId);
    const job = { controller: new AbortController(), grid, button: btn, label: btn.textContent };
    moreRequest = job;
    const current = () => moreRequest === job && !job.controller.signal.aborted &&
      grid.isConnected && btn.isConnected && root.querySelector('[data-efxc-grid]') === grid;
    btn.disabled = true;
    btn.textContent = 'Loading…';
    try {
      const r = await fetch(u.toString(), { signal: job.controller.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!r.ok) throw new Error(r.status);
      const html = await r.text();
      if (!current()) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextGrid = doc.querySelector('[data-efxc-grid]');
      if (!nextGrid) throw new Error('no grid');
      const added = [...nextGrid.children];
      added.forEach(el => grid.appendChild(el));
      arrangeFilms();
      const oldMore = btn.closest('.efxc-more');
      const newMore = doc.querySelector('.efxc-more');
      if (newMore) oldMore.replaceWith(newMore); else oldMore.remove();
      if (added[0]) added[0].querySelector('a, button')?.focus?.({ preventScroll: true });
    } catch (error) {
      if (error.name === 'AbortError' || !current()) return;
      location.href = pretty;
    } finally {
      if (moreRequest === job) {
        moreRequest = null;
        if (btn.isConnected) { btn.disabled = false; btn.textContent = job.label; }
      }
    }
  }

  /* ---------- Drawer ---------- */
  const drawer = root.querySelector('[data-efxc-drawer]');
  let lastFocus = null, previousOverflow = '';
  if (drawer) drawer.inert = true;
  function openDrawer() {
    if (!drawer || drawer.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    drawer.inert = false;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    drawer.querySelector('button[data-efxc-close-drawer]')?.focus({ preventScroll: true });
    // The theme transitions inherited visibility; wait until focus can land.
    const focusDeadline = performance.now() + 1000;
    requestAnimationFrame(function focusWhenVisible() {
      if (!drawer.classList.contains('is-open') || drawer.contains(document.activeElement)) return;
      const close = drawer.querySelector('button[data-efxc-close-drawer]');
      if (close && getComputedStyle(close).visibility === 'visible') close.focus({ preventScroll: true });
      else if (performance.now() < focusDeadline) requestAnimationFrame(focusWhenVisible);
    });
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.inert = true;
    document.documentElement.style.overflow = previousOverflow;
    lastFocus?.focus?.({ preventScroll: true });
  }
  document.addEventListener('keydown', e => {
    if (!drawer?.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    const controls = [...drawer.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')].filter(el =>
      !el.disabled && el.tabIndex >= 0 && !el.closest('[inert]') && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
    const first = controls[0], last = controls.at(-1);
    if (!first) return;
    if (!drawer.contains(document.activeElement) || (e.shiftKey && document.activeElement === first) || (!e.shiftKey && document.activeElement === last)) {
      e.preventDefault(); (e.shiftKey ? last : first).focus({ preventScroll: true });
    }
  });

  fpModels?.start();

  /* ---------- Back / forward ---------- */
  window.addEventListener('popstate', () => {
    const s = readState(location.href);
    state.tags = s.tags; state.sort = s.sort; state.priceMin = s.priceMin; state.priceMax = s.priceMax;
    load(location.pathname + location.search, { push: false });
  });
}

/* Mantel films follow the product they demonstrate. Reorder real DOM nodes so
   keyboard/reading order matches the grid; never use dense visual packing.
   Steel starts a row before its product. Lexington follows its Flat Sawn cards
   on the right of a wide row, or below those cards on mobile. Unrelated cards retain their relative order
   except the few cards needed to finish a row before a film. */
function mantelFilmPairing(root) {
  if (root.hasAttribute('data-ef-compact-films')) return () => {}; // Films attach to their product without taking grid slots.
  // This collection has a stable, server-rendered material order and film placement.
  if (root.dataset.collectionUrl === '/collections/non-combustible-mantel-shelves') return () => {};
  const collections = ['mantel-shelves', 'non-combustible-mantel-shelves', 'concrete-mantel-shelves', 'steel-mantel-shelves'];
  if (!collections.some(handle => root.dataset.collectionUrl === '/collections/' + handle)) return () => {};
  const originals = new WeakMap();
  let previousColumns;
  function arrange() {
    const grid = root.querySelector('[data-efxc-grid]');
    if (!grid) return;
    const children = [...grid.children];
    const saved = originals.get(grid) || [];
    const nodes = saved.filter(n => n.parentElement === grid);
    children.forEach(n => { if (!nodes.includes(n)) nodes.push(n); });
    originals.set(grid, nodes);
    const columns = getComputedStyle(grid).gridTemplateColumns.split(' ').length;
    previousColumns = columns;
    const cards = nodes.filter(n => n.matches('a.efx-card, [data-efmc-card].efx-card'));
    const films = nodes.filter(n => n.matches('[data-efv-tile]'));
    // This adaptation applies only to the existing mantel product/video grid.
    if (nodes.some(n => !cards.includes(n) && !films.includes(n))) return;
    const handle = card => new URL(card.getAttribute('href') || card.querySelector('[data-efmc-link]')?.getAttribute('href'), location.origin).pathname.split('/').pop();
    const pairs = new Map();
    films.forEach(tile => {
      const label = tile.querySelector('[data-efv]')?.dataset.efvLabel;
      let card;
      if (label === 'lexington-flat-sawn-detail') {
        card = cards.find(c => handle(c) === 'flat-sawn-non-combustible-mantel-shelf-pale-honey-finish')
          || cards.find(c => handle(c).startsWith('flat-sawn-non-combustible-mantel-shelf-'))
          || cards.find(c => handle(c) === 'custom-non-combustible-mantel');
      } else if (label === 'stoll-shelves-made') {
        card = cards.find(c => handle(c) === 'custom-steel-fireplace-mantel-shelves-non-combustible-exceptional-fire')
          || cards.find(c => handle(c) === 'fireplace-mantle-shelves-non-combustible-steel-standard-size');
      }
      tile.style.display = card ? '' : 'none';
      if (card) { pairs.set(card, tile); tile.dataset.efvPairedProduct = handle(card); }
      else { delete tile.dataset.efvPairedProduct; tile.querySelector('video')?.pause(); }
    });
    const queue = [...cards], ordered = [];
    let units = 0;
    while (queue.length) {
      const card = queue.shift(), film = pairs.get(card);
      if (film) {
        while (units % columns) {
          const filler = queue.findIndex(c => !pairs.has(c));
          if (filler < 0) break;
          ordered.push(queue.splice(filler, 1)[0]); units++;
        }
        if (film.querySelector('[data-efv]')?.dataset.efvLabel === 'lexington-flat-sawn-detail') {
          ordered.push(card); units++;
          const productSlots = columns > 2 ? columns - 2 : columns;
          for (let slot = 1; slot < productSlots; slot++) {
            let companion = queue.findIndex(c => !pairs.has(c) && handle(c).startsWith('flat-sawn-non-combustible-mantel-shelf-'));
            if (companion < 0) companion = queue.findIndex(c => !pairs.has(c));
            if (companion < 0) break;
            ordered.push(queue.splice(companion, 1)[0]); units++;
          }
          ordered.push(film); units += Math.min(2, columns);
          continue;
        }
        ordered.push(film); units += Math.min(2, columns);
      }
      ordered.push(card); units++;
    }
    films.forEach(f => { if (!ordered.includes(f)) ordered.push(f); });
    // Avoid detaching every element (and interrupting a playing video).
    ordered.forEach((node, index) => {
      if (grid.children[index] !== node) {
        if (grid.moveBefore) grid.moveBefore(node, grid.children[index] || null);
        else grid.insertBefore(node, grid.children[index] || null);
      }
    });
  }
  window.addEventListener('resize', () => {
    const grid = root.querySelector('[data-efxc-grid]');
    if (grid && getComputedStyle(grid).gridTemplateColumns.split(' ').length !== previousColumns) arrange();
  }, {passive: true});
  return arrange;
}
